import { PARTICIPANT_COPY_CS } from './cs.js';
import { PARTICIPANT_COPY_DA } from './da.js';
import { PARTICIPANT_COPY_DE } from './de.js';
import { PARTICIPANT_COPY_EN } from './en.js';
import { PARTICIPANT_COPY_ES } from './es.js';
import { PARTICIPANT_COPY_FI } from './fi.js';
import { PARTICIPANT_COPY_FR } from './fr.js';
import { PARTICIPANT_COPY_KO } from './ko.js';
import { PARTICIPANT_COPY_NB } from './nb.js';
import { PARTICIPANT_COPY_NL } from './nl.js';
import { PARTICIPANT_COPY_PL } from './pl.js';
import { PARTICIPANT_COPY_PT } from './pt.js';
import { PARTICIPANT_COPY_SV } from './sv.js';
const DEFAULTS = {
    en: PARTICIPANT_COPY_EN,
    sv: PARTICIPANT_COPY_SV,
    nl: PARTICIPANT_COPY_NL,
    de: PARTICIPANT_COPY_DE,
    fr: PARTICIPANT_COPY_FR,
    es: PARTICIPANT_COPY_ES,
    da: PARTICIPANT_COPY_DA,
    fi: PARTICIPANT_COPY_FI,
    nb: PARTICIPANT_COPY_NB,
    pt: PARTICIPANT_COPY_PT,
    pl: PARTICIPANT_COPY_PL,
    cs: PARTICIPANT_COPY_CS,
    ko: PARTICIPANT_COPY_KO,
};
/** Norwegian is `no` to the participant app and `nb` to the conversations. */
const ALIASES = { no: 'nb' };
/** The language with its own texts that a language (`sv`) or a locale (`sv-SE`) names, if any. */
function nativeLanguageOf(language) {
    const code = language.trim().toLowerCase().split(/[-_]/)[0] ?? '';
    const known = ALIASES[code] ?? code;
    return Object.hasOwn(DEFAULTS, known) ? known : null;
}
/**
 * Clair's default texts in a language, read from a language (`sv`) or a
 * locale (`sv-SE`); English for a language without its own.
 */
export function participantCopyDefaults(language) {
    return DEFAULTS[nativeLanguageOf(language) ?? 'en'];
}
/**
 * Whether Clair's texts are written in a language (`sv`) or a locale's
 * language (`sv-SE`) natively, so participantCopyDefaults gives that
 * language's own texts and not the English fallback.
 */
export function hasNativeParticipantCopy(language) {
    return nativeLanguageOf(language) !== null;
}
//# sourceMappingURL=participantCopyDefaults.js.map